import * as jsxRuntime from "/home/drago/Work/AgLeaseCo/monorepo2/ui/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment